import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import { trackEvent, EVENT_TYPE_PAGE } from "../utils/trackEvent.jsx";
import MultiStepForm from "./carousel/MultiStepForm.jsx";
import blogContent from "./blogContent.md?raw";
import halalInvestmentOpportunities from "./halalInvestmentOpportunities.md?raw";

// Each blog post must have a content property containing the markdown content
const blogPosts = {
  "things-to-remember-while-applying-for-riba-free-loans": {
    id: 1,
    title: "Things to Remember While Applying for Riba-Free Loans: A Guide for Small Businesses & Nonprofits",
    content: blogContent,
    date: "April 30, 2025",
    author: "Sabina Yasmin",
    image: "/blog1.jpg"
  },
  "halal-investment-opportunities": {
    id: 2,
    title: "Halal Investment Opportunities",
    content: halalInvestmentOpportunities,
    date: "March 10, 2024",
    author: "Dr. Ahmed Hassan",
    image: "/blog2.jpg"
  }
};

function BlogPost() {
  const { slug } = useParams();
  const post = blogPosts[slug];

  useEffect(() => {
    trackEvent(EVENT_TYPE_PAGE);
  }, []);

  if (!post) {
    return (
      <div className="min-h-screen bg-gradient-to-r from-[#f8fafc] to-[#e2e8f0] py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-3xl font-bold text-[#1a4a1a] mb-4">Post Not Found</h1>
          <p className="text-gray-600 mb-8">The blog post you're looking for doesn't exist.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-r from-[#f8fafc] to-[#e2e8f0] py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row gap-8">
          {/* Blog Content */}
          <div className="md:w-2/3">
            <article className="bg-white rounded-xl shadow-md p-6 md:p-8">
              <h1 className="text-3xl md:text-4xl font-bold text-[#1a4a1a] mb-4">
                {post.title}
              </h1>
              <div className="flex items-center gap-4 mb-8 text-gray-600">
                <span>{post.author}</span>
                <span>•</span>
                <span>{post.date}</span>
              </div>
              <div className="prose max-w-none leading-loose prose-headings:text-[#1a4a1a] prose-a:text-[#1a4a1a] prose-a:no-underline hover:prose-a:underline prose-strong:text-[#1a4a1a]">
                <ReactMarkdown>{post.content}</ReactMarkdown>
              </div>
            </article>
          </div>

          {/* MultiStep Form */}
          <div className="md:w-1/3">
            <div className="bg-white rounded-xl shadow-md p-2 sticky top-8">
              <MultiStepForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BlogPost; 